import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Error boundary to catch initialization errors
class ErrorBoundary extends React.Component<
  {children: React.ReactNode},
  {hasError: boolean; error: Error | null}
> {
  constructor(props: {children: React.ReactNode}) {
    super(props);
    this.state = {hasError: false, error: null};
  }

  static getDerivedStateFromError(error: Error) {
    return {hasError: true, error};
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('App error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          padding: '2rem',
          fontFamily: 'system-ui, sans-serif'
        }}>
          <h1 style={{color: '#e74c3c', marginBottom: '1rem'}}>⚠️ Application Error</h1>
          <p style={{color: '#666', marginBottom: '1rem', textAlign: 'center', maxWidth: '500px'}}>
            The application encountered an error. This is likely due to missing Firebase configuration.
          </p>
          <div style={{
            backgroundColor: '#f8f9fa',
            padding: '1rem',
            borderRadius: '6px',
            maxWidth: '600px',
            marginTop: '1rem'
          }}>
            <h3 style={{fontSize: '1rem', marginBottom: '0.5rem'}}>To fix this:</h3>
            <ol style={{textAlign: 'left', lineHeight: '1.8'}}>
              <li>Create a <code>.env</code> file in the project root</li>
              <li>Add your Firebase configuration values</li>
              <li>Rebuild and redeploy: <code>npm run build && firebase deploy --only hosting</code></li>
            </ol>
            <p style={{marginTop: '1rem', fontSize: '0.875rem', color: '#666'}}>
              See <code>SETUP_INSTRUCTIONS.md</code> for detailed steps.
            </p>
          </div>
          <button
            onClick={() => window.location.reload()}
            style={{
              marginTop: '1rem',
              padding: '0.75rem 1.5rem',
              backgroundColor: '#3498db',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              cursor: 'pointer'
            }}
          >
            Reload Page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
